import { AxiosRequestConfig } from 'axios';
import saveAs from 'file-saver';
import { useAxios } from 'hooks';
import { bargeTripExportFilterDto } from './bargeTripInputs';

export const useBargeTripAPI = () => {
  const api = '/api/bargeTrip';
  const { create } = useAxios();

  const getExportFile = async (payload: bargeTripExportFilterDto) => {
    try {
      const axios = await create();
      const response = await axios.post(`${api}/export`, payload, {
        responseType: 'blob'
      });

      if (!response || !response.data) {
        return undefined;
      }

      const filename =
        response.headers['content-disposition']
          .split(';')
          .find((n: any) => n.includes('filename='))
          ?.replace('filename=', '')
          .trim() || 'bargeTrips.xlsx';
      const url = window.URL.createObjectURL(new Blob([response.data]));
      saveAs(url, filename);
    } catch {
      return undefined;
    }
  };

  const uploadBargeTrips = async (formData: FormData, uploadCallback?: (progress: number) => void) => {
    const axios = await create();
    const config: AxiosRequestConfig<FormData> = {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total === undefined) {
          return;
        }
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        uploadCallback && uploadCallback(percentage);
      },
      responseType: 'blob'
    };
    const response = await axios.post(`${api}/upload`, formData, config);
    const filename =
      response.headers['content-disposition']
        .split(';')
        .find((n: any) => n.includes('filename='))
        ?.replace('filename=', '')
        .trim() || 'bargeTrips.xlsx';
    const url = window.URL.createObjectURL(new Blob([response.data]));
    saveAs(url, filename);
  };

  return {
    getExportFile,
    uploadBargeTrips
  };
};
